import HeaderCartShow from "./HeaderCartShow";
import {Link} from "@/i18n/routing";
import {useTranslations} from 'next-intl';
import HeaderAccountSelector from '@/components/layout/headers/HeaderAccountSelector';
import Form from 'next/form';

export default function HeaderRight2({headerStyle, currency}) {
  const t = useTranslations('header');
  return (
    <div className="col px-2">
      {/* <!-- header-options --> */}
      <div className="ltn__header-options">
        <ul>
          <li className="d-lg-none">
            {/* <!-- header-search-1 --> */}
            <div className="header-search-wrap">
              <div className="header-search-1">
                <div className="search-icon">
                  <i className="icon-search  for-search-show"></i>
                  <i className="icon-cancel  for-search-close"></i>
                </div>
              </div>
              <div className="header-search-1-form">
                <Form action="/catalog">
                  <input
                      type="text"
                      name="search"
                      placeholder={t('searchHere')}
                  />
                  <button type="submit">
                    <span>
                      <i className="icon-search"></i>
                    </span>
                  </button>
                </Form>
              </div>
            </div>
          </li>{" "}
          <li>
            {/* <!-- user-menu --> */}
            <HeaderAccountSelector/>
          </li>
          {' '}
          <li>
            {/* <!-- mini-cart 2 --> */}
            <HeaderCartShow headerStyle={headerStyle} currency={currency}/>
          </li>
          {' '}
          <li className="d-none">
            {/* <!-- Mobile Menu Button --> */}
            <div className="mobile-menu-toggle d-lg-none d-none">
              <Link
                  href="#ltn__utilize-mobile-menu"
                className="ltn__utilize-toggle"
              >
                <svg viewBox="0 0 800 600">
                  <path
                    d="M300,220 C300,220 520,220 540,220 C740,220 640,540 520,420 C440,340 300,200 300,200"
                    id="top"
                  ></path>
                  <path d="M300,320 L540,320" id="middle"></path>
                  <path
                    d="M300,210 C300,210 520,210 540,210 C740,210 640,530 520,410 C440,330 300,190 300,190"
                    id="bottom"
                    transform="translate(480, 320) scale(1, -1) translate(-480, -318) "
                  ></path>
                </svg>
              </Link>
            </div>
          </li>
        </ul>
      </div>
    </div>
  );
};
